/** Sentinel ID for the fixed Popular tab — not a real category */
export const POPULAR_TAB_ID = '__popular__';

/**
 * Real L1 category ID for Conditional contracts, as returned by the category
 * tree endpoint. Replaced the former `__conditional__` sentinel once the backend
 * started returning the category. It arrives `restricted: true`, so it only
 * appears in the tree for clients sending the x-internal header
 * (see shouldShowRestricted / getInternalHeaders).
 *
 * Also identifies conditional markets when the product response omits its marker.
 */
export const CONDITIONAL_CATEGORY_ID = 'g2336045';
